(function(){
  'use strict';
  function rand(min,max){ return Math.floor(Math.random()*(max-min+1)+min); }
  var sparkleSvg = '<svg class="jspt-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14.187 8.096L15 5.25l.813 2.846A4.5 4.5 0 0 0 18.903 11.186L21.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09L15 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L8.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09Z"/><path d="m6 14.25-.259 1.035a3.37 3.37 0 0 1-2.456 2.456L2.25 18l1.035.259a3.37 3.37 0 0 1 2.456 2.456L6 21.75l.259-1.035a3.37 3.37 0 0 1 2.455-2.456L9.75 18l-1.036-.259a3.37 3.37 0 0 1-2.455-2.456L6 14.25Z"/><path d="m6.5 4-.197.592a1.13 1.13 0 0 1-.711.711L5 5.5l.592.197c.33.11.59.37.711.711L6.5 7l.197-.592c.11-.33.37-.59.711-.711L8 5.5l-.592-.197a1.13 1.13 0 0 1-.711-.711L6.5 4Z"/></svg>';

  function enhance(tab, extraClass){
    if(!tab || tab.dataset.jsSparkReady==='1') return;
    tab.dataset.jsSparkReady='1';
    if(extraClass) tab.classList.add(extraClass);
    var label = tab.textContent.trim();
    tab.textContent='';
    var spark=document.createElement('span'); spark.className='jspt-spark'; spark.setAttribute('aria-hidden','true');
    var backdrop=document.createElement('span'); backdrop.className='jspt-backdrop'; backdrop.setAttribute('aria-hidden','true');
    var iconWrap=document.createElement('span'); iconWrap.innerHTML=sparkleSvg;
    var icon=iconWrap.firstChild;
    var text=document.createElement('span'); text.className='jspt-label'; text.textContent=label;
    var particles=document.createElement('span'); particles.className='jspt-particles'; particles.setAttribute('aria-hidden','true');
    for(var i=0;i<12;i++){
      var p=document.createElement('span'); p.className='jspt-particle';
      p.style.setProperty('--x',rand(12,88));
      p.style.setProperty('--y',rand(18,82));
      p.style.setProperty('--duration',rand(6,18));
      p.style.setProperty('--delay',rand(1,10));
      p.style.setProperty('--alpha',(rand(45,90)/100).toFixed(2));
      p.style.setProperty('--origin-x',(Math.random()>.5?-1:1)*rand(260,680)+'%');
      p.style.setProperty('--origin-y',(Math.random()>.5?-1:1)*rand(260,680)+'%');
      p.style.setProperty('--size',(rand(45,95)/100).toFixed(2));
      particles.appendChild(p);
    }
    tab.appendChild(spark);
    tab.appendChild(backdrop);
    tab.appendChild(icon);
    tab.appendChild(text);
    tab.appendChild(particles);
  }

  function enhancePane(pane){
    if(!pane || pane.dataset.jsSparkPaneReady==='1') return;
    pane.dataset.jsSparkPaneReady='1';
    var panel=document.createElement('div');
    panel.className='jspt-panel';
    while(pane.firstChild){
      panel.appendChild(pane.firstChild);
    }
    pane.appendChild(panel);
  }

  function init(){
    document.querySelectorAll('.prpage-tabs [data-js-spark-tab]').forEach(function(el){ enhance(el,''); });
    document.querySelectorAll('.tt-product-single-info .btn-addtocart').forEach(function(el){ enhance(el,'js-spark-cart'); });
    document.querySelectorAll('.prpage-tabs .tab-content > .tab-pane').forEach(enhancePane);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
